import Cookies from "js-cookie";


export async function userAuthentication(loginCredentials) {
  try {
    const response = await fetch(
      "https://arbitragem.bet:3131/user/authentication/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(loginCredentials),
      }
    );

    const data = await response.json();
    data["statusHttp"] = response.status;

    if (response.ok) {
      return data;
    } else if (data["message"] !== undefined) {
      return data;
    } else {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error) {
    return {
      message: "Erro de conexão. Verifique sua internet.",
      statusHttp: 0,
    };
  }
}

export async function userRegistration(registerCredentials) {
  try {
    const response = await fetch(
      "https://arbitragem.bet:3131/user/register/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(registerCredentials),
      }
    );

    const data = await response.json();
    data["statusHttp"] = response.status;

    if (response.ok) {
      return data;
    } else if (data["message"] !== undefined) {
      return data;
    } else {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error) {
    return {
      message: "Erro de conexão. Verifique sua internet.",
      statusHttp: 0,
    };
  }
}

export async function checkRecoverPasswordSession(token) {
  try {
    let dataToSend = { token };
    const response = await fetch(
      "https://arbitragem.bet:3131/user/check_recover_password_session/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(dataToSend),
      }
    );

    const data = await response.json();
    data["statusHttp"] = response.status;

    if (response.ok) {
      return data;
    } else if (data["message"] !== undefined) {
      return data;
    } else {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error) {
    return {
      message: "Erro de conexão. Verifique sua internet.",
      statusHttp: 0,
    };
  }
}

export async function recoverPassword(email) {
  try {
    let dataToSend = { email };
    const response = await fetch(
      "https://arbitragem.bet:3131/user/recover_password/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(dataToSend),
      }
    );

    const data = await response.json();
    data["statusHttp"] = response.status;

    if (response.ok) {
      return data;
    } else if (data["message"] !== undefined) {
      return data;
    } else {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error) {
    return {
      message: "Erro de conexão. Verifique sua internet.",
      statusHttp: 0,
    };
  }
}

export async function renewPassword(password, token) {
  try {
    let dataToSend = { token: token, password: password };
    const response = await fetch(
      "https://arbitragem.bet:3131/user/renew_password/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(dataToSend),
      }
    );

    const data = await response.json();
    data["statusHttp"] = response.status;

    if (response.ok) {
      return data;
    } else if (data["message"] !== undefined) {
      return data;
    } else {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error) {
    return {
      message: "Erro de conexão. Verifique sua internet.",
      statusHttp: 0,
    };
  }
}

export async function updatePassword(password) {
  try {
    const b4726486 = Cookies.get("b4726486");
    let dataToSend = { b4726486: b4726486, password: password };
    const response = await fetch(
      "https://arbitragem.bet:3131/user/update_password/",
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(dataToSend),
      }
    );

    const data = await response.json();
    data["statusHttp"] = response.status;

    if (response.ok) {
      return data;
    } else if (data["message"] !== undefined) {
      return data;
    } else {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error) {
    return {
      message: "Erro de conexão. Verifique sua internet.",
      statusHttp: 0,
    };
  }
}

export async function updatePhone(phone) {
  try {
    const b4726486 = Cookies.get("b4726486");
    let dataToSend = { b4726486: b4726486, phone: phone };
    const response = await fetch(
      "https://arbitragem.bet:3131/user/update_phone/",
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(dataToSend),
      }
    );

    const data = await response.json();
    data["statusHttp"] = response.status;

    if (response.ok) {
      return data;
    } else if (data["message"] !== undefined) {
      return data;
    } else {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error) {
    return {
      message: "Erro de conexão. Verifique sua internet.",
      statusHttp: 0,
    };
  }
}

export async function deleteAccount() {
  try {
    const b4726486 = Cookies.get("b4726486");
    let dataToSend = { b4726486: b4726486 };
    const response = await fetch(
      "https://arbitragem.bet:3131/user/delete_account/",
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(dataToSend),
      }
    );

    const data = await response.json();
    data["statusHttp"] = response.status;

    if (response.ok) {
      return data;
    } else if (data["message"] !== undefined) {
      return data;
    } else {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error) {
    return {
      message: "Erro de conexão. Verifique sua internet.",
      statusHttp: 0,
    };
  }
}
